import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';

import { UsefulToolsService } from './../usefultools.service';
import { SharedService } from '../../shared.service';
import { CustomErrorMessages } from './custom-error-messages';

@Injectable()
export class OwnHttpInterceptor implements HttpInterceptor {
  constructor(
    private usefultoolsservice: UsefulToolsService,
    private sharedservice: SharedService
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // If you need to make changes to the request before it is sent, do it in here ###########################
      // this.sharedservice.loadingActive = true;
    // If you need to make changes to the request before it is sent, do it in here ###########################

    return next.handle(request).pipe(
      map((response: any) => { // when the call doesn't return an error
        // Use this to view the response if you need to check it
        // console.log(response);
        // this.sharedservice.loadingActive = false;

        let errorMessage = '';
        if (!response.hasOwnProperty('body') || response.body.utData_response === null) return response;
        for (const key in response.body) {
          // Many if's just to be 100% sure everything is present
          // If your server error message lies in a different plaace then you need to change these if

          // This is if your error is at:
          // response.utLogin_response.queue[0].ERRORDESCRIPTION
          if (!(response.body[key].hasOwnProperty('queue'))) return response;
          if (!(response.body[key].queue.length > 0)) return response;
          if (!(response.body[key].queue[0].hasOwnProperty('ERRORDESCRIPTION'))) return response;
          errorMessage = response.body[key].queue[0].ERRORDESCRIPTION;

          let errorFound = false;
          CustomErrorMessages.forEach(element => {
            if (errorFound) return;
            if (errorMessage === element.serverMessage) {
              errorMessage = element.customMessage;
              errorFound = true;
            }
          });

          this.usefultoolsservice.notify('error', `Error: ${errorMessage}`);
        }
      }),
      catchError(error => { // when the call returns an error
        this.sharedservice.loadingActive = false;
        this.usefultoolsservice.notify('error', 'A connection could not be establish to the server or the call is wrong. Please contact your administrator for assistance.');
        return error;
      })
    );
  }
}
